import { combineReducers } from "redux";
import Login from './Login'
import { reducer as formReducer } from 'redux-form';
import { snackbarReducer } from 'react-redux-snackbar';
import { loadingBarReducer } from 'react-redux-loading-bar'
import ForgetPasswordReducer from  './fogoetpassword'
import SocketReducer from './socketReducer'
export default combineReducers({
   login: Login,
   snackbar: snackbarReducer,
   form: formReducer,
   loadingBar: loadingBarReducer,
   forget:ForgetPasswordReducer,
   socket:SocketReducer,
});
